/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetTypeUsageDto,
    AssetTypeUsageDtoFromJSON,
    AssetTypeUsageDtoFromJSONTyped,
    AssetTypeUsageDtoToJSON,
} from './AssetTypeUsageDto';
import {
    CryptoVsStocksDto,
    CryptoVsStocksDtoFromJSON,
    CryptoVsStocksDtoFromJSONTyped,
    CryptoVsStocksDtoToJSON,
} from './CryptoVsStocksDto';

/**
 * 
 * @export
 * @interface AdminAssetDistributionDto
 */
export interface AdminAssetDistributionDto {
    /**
     * Total number of users for percentage calculation
     * @type {number}
     * @memberof AdminAssetDistributionDto
     */
    totalUsers: number;
    /**
     * Crypto vs Stocks comparison
     * @type {CryptoVsStocksDto}
     * @memberof AdminAssetDistributionDto
     */
    cryptoVsStocks: CryptoVsStocksDto | null;
    /**
     * Asset type usage breakdown
     * @type {Array<AssetTypeUsageDto>}
     * @memberof AdminAssetDistributionDto
     */
    assetTypes: Array<AssetTypeUsageDto>;
}

export function AdminAssetDistributionDtoFromJSON(json: any): AdminAssetDistributionDto {
    return AdminAssetDistributionDtoFromJSONTyped(json, false);
}

export function AdminAssetDistributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAssetDistributionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalUsers': json['totalUsers'],
        'cryptoVsStocks': CryptoVsStocksDtoFromJSON(json['cryptoVsStocks']),
        'assetTypes': ((json['assetTypes'] as Array<any>).map(AssetTypeUsageDtoFromJSON)),
    };
}

export function AdminAssetDistributionDtoToJSON(value?: AdminAssetDistributionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalUsers': value.totalUsers,
        'cryptoVsStocks': CryptoVsStocksDtoToJSON(value.cryptoVsStocks),
        'assetTypes': ((value.assetTypes as Array<any>).map(AssetTypeUsageDtoToJSON)),
    };
}

